"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var SocialIcons_1 = tslib_1.__importDefault(require("../SocialIcons"));
function getHref(name, url, title) {
    switch (name) {
        case 'facebook':
            return "https://www.facebook.com/sharer/sharer.php?u=".concat(url);
        case 'linkedin':
            return "https://www.linkedin.com/sharing/share-offsite/?url=".concat(url);
        case 'twitter':
            return "https://twitter.com/intent/tweet?url=".concat(url);
        case 'tumblr':
            return "http://tumblr.com/widgets/share/tool?canonicalUrl=".concat(url);
        case 'pinterest':
            return "http://pinterest.com/pin/create/button/?url=".concat(url);
        case 'mail':
            return "mailto:?subject=".concat(title, "&body=").concat(url);
        default:
            return null;
    }
}
var SocialShare = function (_a) {
    var _b = _a.config, config = _b === void 0 ? {} : _b, url = _a.url, title = _a.title, className = _a.className, _c = _a.size, size = _c === void 0 ? 32 : _c, variant = _a.variant;
    if (!variant) {
        return null;
    }
    var configKeys = Object.keys(config);
    return (React.createElement(SocialIcons_1["default"], { className: className, icons: configKeys, size: size, variant: variant, renderIcon: function (icon, children) {
            var href = getHref(icon, url, title);
            if (href) {
                return (React.createElement("a", { href: href, target: "_blank", rel: "noopener noreferrer" }, children));
            }
            return null;
        } }));
};
exports["default"] = SocialShare;
